import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import CusCard from '../containers/CusCardContainer'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';




class ManageReports extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (           
                <Row>
                    <CusCard data1="General" data2="Reports" icon="credit-card" link="./GeneralReports" ></CusCard>
                    <CusCard data1="Trend" data2="Reports" icon="grid" link="./TrendReports"></CusCard>
                    <CusCard data1="Vehicle Movement" data2="Report" icon="minimize-2" link="./TrackerReport"></CusCard>
                </Row>

        );
    }
}


export default ManageReports;